import fetch from "@/uilts/request";



export default {
    orderSign(data){
        return fetch.post("/Sign/orderSign",data)
    },
    getMemberSign(data){
        return fetch.post("/Sign/getMemberSign",data)
    },
    getMemberRz(data){
        return fetch.post("/Sign/getMemberRz",data)
    },
    signDeductionSubmit(data){
        return fetch.post("/Sign/signDeductionSubmit",data)
    },
    signGetList(data){
        return fetch.post("/Sign/getList",data)
    }

}